export const CONTACT_FORM_LABELS = {
  singular:      'Contact',
  plural:        'Contacts',
  addAction:     'Add Contact',
  createAction:  'Create Contact',
  editAction:    'Edit Contact',
  createAndLink: 'Create & Link',
  addToSystem:   'Add to System & Select',
  saveChanges:   'Save Changes',
  addPhone:      'Add Phone',
  addEmail:      'Add Email',
  removePhone:   'Remove Phone',
  removeEmail:   'Remove Email',
  primary:       'Primary',
} as const;

export const CONTACT_FIELD_LABELS: Record<string, { label: string; placeholder: string }> = {
  name:         { label: 'Name',          placeholder: 'Full name' },
  defaultRoles: { label: 'Default Roles', placeholder: '— Select Roles —' },
  company:      { label: 'Company',       placeholder: 'Company name' },
  title:        { label: 'Title',         placeholder: 'Job title' },
  phoneNumbers: { label: 'Phone Numbers', placeholder: '(555) 555-0000' },
  emails:       { label: 'Email Addresses', placeholder: 'email@example.com' },
  address:      { label: 'Address',       placeholder: 'Street address' },
  phoneType:    { label: 'Type',          placeholder: 'Phone type' },
  emailType:    { label: 'Type',          placeholder: 'Email type' },
  extension:    { label: 'Ext.',          placeholder: 'Ext.' },
};
